@if (timeOut()) {
  <app-timeout></app-timeout>
} @else if (loading()) {
  <div class="flex h-full w-full justify-content-center align-items-center">
    <p-progressSpinner ariaLabel="loading" class="customProgressSpinner" />
  </div>
}
<div class="gatePositionChartContainer h-full" [ngClass]="{ hide: loading() || timeOut() }">
  <div class="labels">
    @if (gatePositions()) {
      @for (position of gatePositions(); track position) {
        <div class="label">
          <app-svg-icon [iconName]="position.icon" [iconColor]="position.color" iconSize="m"></app-svg-icon
          ><span class="text-center">{{ position.label | translate }}</span>
        </div>
      }
    }
  </div>
  <div class="chartContainer">
    <canvas #chartCanvas [id]="chartId()" class="chart"> </canvas>
  </div>

  <div class="values">
    @for (position of gatePositions(); track position) {
      <div>{{ position.value }}</div>
    }
  </div>
</div>
